/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "eu-west-2",
  aws_cognito_identity_pool_id: "eu-west-2:38679c4f-8057-4581-970b-b4fe996220d0",
  aws_cognito_region: "eu-west-2",
  aws_user_pools_id: "eu-west-2_gTfXgDpaM",
  aws_user_pools_web_client_id: "4ae7f71l3bqcmfnbe4m5i8jras",
  oauth: {
    domain: "yakkrinternalea44d09a-ea44d09a-dev.auth.eu-west-2.amazoncognito.com",
    scope: ["phone", "email", "openid", "profile", "aws.cognito.signin.user.admin"],
    redirectSignIn: "https://yakkr.co.uk/,https://yakkr.co.uk/",
    redirectSignOut: "https://yakkr.co.uk/,https://yakkr.co.uk/",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["FACEBOOK", "GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint:
    "https://zyc3uyyuj5bh3ezkfpsdlq4l5a.appsync-api.eu-west-2.amazonaws.com/graphql",
  aws_appsync_region: "eu-west-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "da2-4abq52uqyfhp3dbvsmxwqulsz4",
};

export default awsmobile;
